import api from '../../../App/socket';

export const addUser = params => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'AddUser',
        options: {
            create: params,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/requests/add_user_request.js